import Button from '@/components/Button';
import {
  AUTH_EMAIL_EXPECTED_SENDER,
  AUTH_EMAIL_SPAM_HELP,
} from '@/lib/authEmail';
import ResendVerificationCallout, {
  type ResendStatus,
} from './ResendVerificationCallout';

type AuthSuccessRegisterProps = {
  cooldownSecondsRemaining: number | null;
  email?: string | null;
  errorMessage?: string;
  isResendingVerification: boolean;
  onBackToSignIn: () => void;
  onResend: (email: string) => void;
  resendStatus: ResendStatus;
};

const AuthSuccessRegister = ({
  cooldownSecondsRemaining,
  email,
  errorMessage,
  isResendingVerification,
  onBackToSignIn,
  onResend,
  resendStatus,
}: AuthSuccessRegisterProps) => {
  const registeredEmail =
    typeof email === 'string' ? email.trim().toLowerCase() : '';

  return (
    <div className="space-y-6 text-sm leading-normal text-black">
      <p>A verification email is on its way to {email}.</p>
      <p>
        Look for an email from {AUTH_EMAIL_EXPECTED_SENDER}.{' '}
        {AUTH_EMAIL_SPAM_HELP}
      </p>
      {errorMessage && (
        <p className="text-center text-red-600">{errorMessage}</p>
      )}
      {registeredEmail && (
        <ResendVerificationCallout
          email={registeredEmail}
          status={resendStatus}
          cooldownSecondsRemaining={cooldownSecondsRemaining}
          isLoading={isResendingVerification}
          onResend={() => onResend(registeredEmail)}
        />
      )}

      <Button
        type="button"
        className="w-full justify-center text-center"
        onClick={onBackToSignIn}
      >
        Back to Sign in
      </Button>
    </div>
  );
};

export default AuthSuccessRegister;
